
//@ts-nocheck
import { Question } from '../components/questions'

window.addEventListener('load', () => {
  Question()
})